import { get } from "app/utils/axios/kheti";
import { Treatment } from "../models/diagnosis";

const fetchDiseaseTreatment = async (plantixId: string, diseaseId: number) => {
  try {
    const response = await get<Treatment>(
      `plantix/v1/${plantixId}/disease/${diseaseId}/treatment`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default fetchDiseaseTreatment;
